import * as React from "react";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import { sort } from "../../../utils/data";
import { ILocalization } from "../../../models/localization";
import { hashHistory } from "react-router";
import { LookupValue, IInMemLookup } from "../../../models/lookup";
import { ProfileSkillState, ScreenMode, LookupType, JobType, EdType } from "../../../models/enums";
import { ExperienceSkill, ProfileSkill, WorkExperience, EducationExperience, ActivityExperience, CCLCExperience } from "../../../models/profile";
import SeekerStore from "../../../stores/seekerStore";
import { SkillSuggestion } from "../../../models/skills";
import { FormControl, FormControlLabel } from "material-ui/Form";
import Select from "material-ui/Select"
import { Row, Col } from "react-flexbox-grid";
import Autosuggest from "react-autosuggest";
import TextField from "material-ui/TextField";
import { MenuItem } from "material-ui/Menu";
import Paper from "material-ui/Paper";
import { Chart } from "react-google-charts";
import List from "material-ui/List";
import Button from "material-ui/Button";
import * as s from "./skillMapping.css";

@observer
export class SkillsGraph extends React.Component<{ store: SeekerStore }, {}> {
  private skillChartRef: HTMLDivElement;
  constructor(props: any) {
    super(props);
    this.skillChartRef = null;
  }

  scrollToBottom = () => {
    this.skillChartRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  renderChart(): JSX.Element[] {
    if (!this.props.store.profileStore.selectedSkill) {
      return null;
    }
    const local: ILocalization = this.props.store.localization.fields;
    const items: Array<(string | number)[] | (string | { "role": string; })[]> = [];
    items.push(["Skill", local.freq, { "role": "style" }]);

    this.props.store.profileStore.profile.jobs.map((experience: WorkExperience, i: number): void => {
      experience.skills.map((skill: ExperienceSkill): void => {
        let use: number = 7 - skill.used;
        if (skill.skillId === this.props.store.profileStore.selectedSkill.idHash) {
          items.push([experience.position, use, "color: #0072CE"]);       
        }
      })
    })
    this.props.store.profileStore.profile.educations.map((education: EducationExperience, i: number): void => {
      education.skills.map((skill: ExperienceSkill): void => {
        let use: number = 7 - skill.used;
        if (skill.skillId === this.props.store.profileStore.selectedSkill.idHash) {
          items.push([education.name, use, "color: #0072CE"]);
        }
      })
    })
    this.props.store.profileStore.profile.activities.map((activity: ActivityExperience, i: number): void => {
      activity.skills.map((skill: ExperienceSkill): void => {
        let use: number = 7 - skill.used;
        if (skill.skillId === this.props.store.profileStore.selectedSkill.idHash) {
          items.push([activity.role, use, "color: #0072CE"]);
        }
      })
    })

    const chart: JSX.Element[] = [];
    if (items.length > 1) {
      chart.push(<div key={"skills-to-exp-chart"}>
        <Chart
          graph_id="ExperienceChart"
          chartType="BarChart"         
          data={items}
          options={{
            "bar": { "groupWidth": "50%" },
            "legend": { "position": "none" },
            "chartEvents": [{ "eventName": "onmouseover" }],
            "hAxis": {
              "title": local.freq,
              "ticks": [{ v: 0, f: local.profile.never }, { v: 1, f: local.profile.yearly }, { v: 2, f: local.profile.monthly }, { v: 3, f: local.profile.biweekly }, { v: 4, f: local.profile.weekly }, { v: 5, f: local.profile.week23 }, { v: 6, f: local.profile.daily }],
              "slantedText": true,
              "slantedTextAngle": 45,
              "format": 0
            },
             "chartArea": {
               "left": "20%",
               "top": "5%",
               "height": "auto",
               "width": "90%",
             },            
          }}
          width="100%"
          height="450px"
          legend_toggle />
      </div>)
    } else {
      chart.push(<div key="no-skills"><p>{local.profile.associatedExpDefaultMsg}</p></div>);
      }
    return chart;
  }

  render(): JSX.Element {
    if (!this.props.store.profileStore.profile) {
      return null;
    }
    const local: ILocalization = this.props.store.localization.fields;
    const ps: ProfileSkill = this.props.store.profileStore.selectedSkill;
    return (<div>
      <div style={{ float: "left", clear: "both" }} ref={(el) => { this.skillChartRef = el; }}></div>
      <h6 className={s.header}>{ps.title}-{local.profile.skillChartHeader}</h6>
      {this.renderChart()} 
    </div>)
  }
}

@observer
export class AddNewSkill extends React.Component<{ store: SeekerStore }, {}> {
  @observable newSkill: string;
  @observable selected: boolean;
  @observable key: string;
  @observable addSkill: SkillSuggestion;
  private addNewSkillRef:  HTMLDivElement;
  constructor(props: any) {
    super(props);
    this.newSkill = "";
    this.selected = false;
    this.key = "";
    this.addSkill = null;
    this.addNewSkillRef = null;
  }

  scrollToBottom = () => {
    this.addNewSkillRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
  }

  componentDidMount(): void {
    this.scrollToBottom(); 
  }

  componentWillUpdate() {
    this.scrollToBottom();
  }

  componentWillUnmount():void {
    this.props.store.profileStore.setRefreshAddSkillVw(false);
  }

  @action clear = () => {
    this.newSkill = "";
    this.addSkill = null;
    this.selected = false;
    this.props.store.profileStore.setRefreshAddSkillVw(false);
  }

  @action onChangePosition = (e: any): void => {
    this.newSkill = e.target.value;
    this.props.store.profileStore.clearSuggestedAutocompleteSkills();
    if (this.newSkill.length > 2) {
      this.props.store.profileStore.getAutoCompleteSkills(this.newSkill);
    }
    this.selected = false;
  }

  @action selectSkill = (skill: SkillSuggestion): void => {
    this.props.store.profileStore.clearSelectedProfileSkill();
    this.newSkill = skill.title;
    this.addSkill = skill;
    this.props.store.profileStore.setSelectedNewSkill(skill);
    this.props.store.profileStore.clearSuggestedAutocompleteSkills();
    this.selected = true;
  }

  renderSkillSuggestions(): JSX.Element {
    if (this.props.store.profileStore.suggestedAutocompleteSkills.length > 0) {
      const items: JSX.Element[] = [];
      sort(this.props.store.profileStore.suggestedAutocompleteSkills, "title").map((s: SkillSuggestion, i: number): void => {
        items.push(<MenuItem style={{whiteSpace: "pre-wrap"}}  key={i} value={s.id} onClick={() => this.selectSkill(s)}>{s.title}</MenuItem>);
      });
      return <Row>
        <Col xs={12} sm={11}><Paper>
          <List>{items}</List>
        </Paper></Col>
      </Row>;
    } else {
      return null;
    }

  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    if(this.props.store.profileStore.refreshAddSkillVw){
       this.clear();
    }  
    return (<div>
      <div style={{ float: "left", clear: "both" }} ref={(el) => { this.addNewSkillRef = el; }}></div>
      <h5 className={s.header}>{local.profile.addNewSkillHeader}</h5>
        <Row>
        <Col xs={12} md={6}>
          <Row>
            <Col xs={12} sm={11}>
              <TextField name="newSkill" id="newSkill" label={local.profile.addNewSkillHeader} placeholder={local.profile.addNewPlaceholder} value={this.newSkill} onChange={this.onChangePosition} onFocus={() => this.props.store.profileStore.clearSuggestedSkills()} fullWidth /><br /><br />
            </Col>
            {this.selected && this.addSkill !== null && <div>
            <Col xs={12} sm={12} mdOffset={1} md={11}><p className={s.boldedText}>{local.profile.skillDescriptionQuestion} {this.addSkill.title}?</p></Col>
            <Col xs={12} sm={12} mdOffset={1} md={11}><div dangerouslySetInnerHTML={{ __html: this.addSkill.description }}></div><br /><br /></Col>
            <Col xs={12} sm={12} mdOffset={1} md={11}>
                <p className={s.newExperienceText}>{local.profile.noExpListedQuestion}</p>
                <p className={s.blueHover} onClick={() => hashHistory.push("/profile/add-experience")}>{local.profile.addNewExp}</p>
            </Col></div>}       
          </Row>
        {this.renderSkillSuggestions()}
        </Col>
        
        <Col xs={12} md={6}>
          <Row>
            <Col xs={12}>
              {this.selected && this.addSkill !== null && <div>
                <p className={s.rightSubHeading} >{local.profile.skillDemonstrateQuestion} <span className={s.highlight}>{this.addSkill.title}</span></p>
                </div>}
            </Col>
          </Row>
          <Row>
            <Col xs={12} className={s.displayBox}>
              {this.selected && <SkillsMap store={this.props.store} />}
             </Col>
          </Row>
          <Row><Col xsOffset={1} xs={10} mdOffset={1} md={8}>{this.selected && <Button raised style={{ margin: "36px" }} color="secondary" onClick={() => this.clear()}>{local.saveAdd}</Button>}</Col></Row>
        </Col>

     </Row>
    </div>)
  }
}


@observer
export class UpdateSkill extends React.Component<{ store: SeekerStore }, {}> {
  private updateSkillRef: HTMLDivElement;
  constructor(props: any) {
    super(props);
    this.updateSkillRef = null;
  }

  scrollToBottom = () => {
    this.updateSkillRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  render(): JSX.Element {
    if (!this.props.store.profileStore.selectedSkill) {
      return null;
    }
    const local: ILocalization = this.props.store.localization.fields;
    let profileSkill: ProfileSkill = this.props.store.profileStore.selectedSkill;

    return (<div>
      <div style={{ float: "left", clear: "both" }} ref={(el) => { this.updateSkillRef = el; }}></div>
      <h5 className={s.header}>{local.profile.updateSkillHeader}</h5>
      <Row>
        <Col xs={12} sm={12} md={6}>
          <Row>
            <Col xs={12}>
              <h6 className={s.leftSubHeading}>{local.profile.youAreUpdating} <span className={s.highlight}>{profileSkill.title}</span></h6>
            </Col>
            <Col xs={12} sm={12} mdOffset={1} md={11}><p className={s.boldedText}>{local.profile.skillDescriptionQuestion} {profileSkill.title}?</p></Col>
            <Col xs={12} sm={12} mdOffset={1} md={11}><div dangerouslySetInnerHTML={{ __html: profileSkill.description }}></div><br /><br /></Col>
            <Col xs={12} sm={12} mdOffset={1} md={11}>
              <p className={s.newExperienceText}>{local.profile.noExpListedQuestion}</p>
              <p className={s.blueHover} onClick={() => hashHistory.push("/profile/add-experience")}>{local.profile.addNewExp}</p>
            </Col>
          </Row>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Row>
            <Col xs={12}>
              <h6 className={s.rightSubHeading} >{local.profile.skillDemonstrateQuestion} <span className={s.highlight}>{profileSkill.title}</span></h6>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className={s.displayBox}>
              <SkillsMap store={this.props.store} />
            </Col>
          </Row>
        </Col>
      </Row> 
    </div>)
  }
}


@observer
export class SkillsMap extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
  }
  render(): JSX.Element {
    let selectedId: string = "";
    if (this.props.store.profileStore.selectedSkill === null) {
      if (this.props.store.profileStore.selectedNewSkill === null) {
        return null;
      } else {
        selectedId = this.props.store.profileStore.selectedNewSkill.id;
      }
    } else {
      selectedId = this.props.store.profileStore.selectedSkill.idHash;
    }
    const local: ILocalization = this.props.store.localization.fields;
    const profileSkill = this.props.store.profileStore.selectedSkill;
    const jobs: Array<WorkExperience> = this.props.store.profileStore.profile.jobs;
    const education: Array<EducationExperience> = this.props.store.profileStore.profile.educations;
    const activities: Array<ActivityExperience> = this.props.store.profileStore.profile.activities;

    const usage: JSX.Element[] = [];
    this.props.store.localization.getLookup(LookupType.UseFrequency).map((lv: LookupValue, i: number): void => {
      usage.push(<MenuItem key={i} value={lv.order}>{lv.value}</MenuItem>);
    });
    const gedUsage: JSX.Element[] = [];
    this.props.store.localization.getLookup(LookupType.GEDUse).map((lv: LookupValue, i: number): void => {
      gedUsage.push(<MenuItem key={i} value={lv.order}>{lv.value}</MenuItem>);
    });
    const edUsage: JSX.Element[] = [];
    this.props.store.localization.getLookup(LookupType.SchoolUse).map((lv: LookupValue, i: number): void => {
      edUsage.push(<MenuItem key={i} value={lv.order}>{lv.value}</MenuItem>);
    });

    let items: JSX.Element[] = [];
    items.length = 0;

    //Display all work & military experience
    jobs.map((e: WorkExperience, i: number): void => {
      let match: boolean = false;
      if (e.skills.length > 0) {
        e.skills.map((skill: ExperienceSkill): void => {
          const es: ExperienceSkill = skill;
          if (es.skillId === selectedId) {
            match = true;
            //if military experience
            if (e.expType === JobType.Military) {
              items.push(<Row key={"w-" + e.idHash} className={s.experienceRow}>
                <Col className={s.experienceCol} xs={12} xl={6}>
                  <p className={s.experienceTextTitle}>{e.position}</p>
                  <div className={s.military}>
                    {this.props.store.localization.getLookup(LookupType.Services).map((service: LookupValue) => {
                      if (service.order === e.service) {
                        return (<p key={"service-" + service.idHash} className={s.employer}>{service.value},&nbsp;</p>)
                      }
                    })}
                    {this.props.store.localization.getLookup(LookupType.ServiceTypes).map((type: LookupValue) => {
                      if (type.order === e.serviceType) {
                        return (<p key={"type-" + type.idHash} className={s.employer}>{type.value}</p>)
                      }
                    })}
                  </div>
                </Col>
                <Col xs={12} xl={6} className={s.selectCol}>
                  <FormControl fullWidth>
                    <Select value={es.used} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, selectedId, event.target.value)}>  //experience Id, the skill Id and the usage index                                         
                      {usage}
                    </Select>
                  </FormControl>
                </Col>
              </Row>
              );
            } else {
              //else regular work experience
              items.push(<Row key={"ww-" + e.idHash} className={s.experienceRow}>
                <Col className={s.experienceCol} xs={12} xl={6}>
                  <p className={s.experienceTextTitle}>{e.position}</p>
                  <p className={s.experienceText}>{e.employer}</p>
                </Col>
                <Col xs={12} xl={6} className={s.selectCol}>
                  <FormControl fullWidth>
                    <Select value={es.used} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, selectedId, event.target.value)}> 
                      {usage}
                    </Select>
                  </FormControl>
                </Col>
              </Row>
              );
            }
          }//end of if there is a match
        })//end of skills map
      }
      // no skills associated with job so check JobType and set usage to none
      if (e.skills.length === 0 || !match) {
        if (e.expType === JobType.Military) {
          items.push(<Row key={"m-" + e.idHash} className={s.experienceRow}>
            <Col className={s.experienceCol} xs={12} xl={6}>
              <p className={s.experienceTextTitle}>{e.position}</p>
              <div className={s.military}>
                {this.props.store.localization.getLookup(LookupType.Services).map((service: LookupValue) => {
                  if (service.order === e.service) {
                    return (<p key={"service-" + service.idHash} className={s.employer}>{service.value},&nbsp;</p>)
                  }
                })}
                {this.props.store.localization.getLookup(LookupType.ServiceTypes).map((type: LookupValue) => {
                  if (type.order === e.serviceType) {
                    return (<p key={"type-" + type.idHash} className={s.employer}>{type.value}</p>)
                  }
                })}
              </div>
            </Col>
            <Col xs={12} xl={6} className={s.selectCol}>
              <FormControl fullWidth>
                <Select value={0} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, selectedId, event.target.value)}> 
                  {usage}
                </Select>
              </FormControl>
            </Col>
          </Row>
          );
        } else {
          //else regular work experience
          items.push(<Row key={"mm-" + e.idHash} className={s.experienceRow}>
            <Col className={s.experienceCol} xs={12} xl={6}>
              <p className={s.experienceTextTitle}>{e.position}</p>
              <p className={s.experienceText}>{e.employer}</p>
            </Col>
            <Col xs={12} xl={6} className={s.selectCol}>
              <FormControl fullWidth>
                <Select value={0} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, selectedId, event.target.value)}> 
                  {usage}
                </Select>
              </FormControl>
            </Col>
          </Row>
          );
        }
      }
    })


      //Display all course and GEDDegree Experience
      education.map((e: EducationExperience, i: number): void => {
        let match: boolean = false;
        if (e.skills.length > 0) {
          e.skills.map((skill: ExperienceSkill): void => {
            const es: ExperienceSkill = skill;
            if (es.skillId === selectedId) {
              match = true;
              if (e.edType === EdType.Course) {
                // if type is Course
                items.push(<Row key={"e-" + e.idHash} className={s.experienceRow}>
                  <Col className={s.experienceCol} xs={12} xl={6}>
                    <p className={s.experienceTextTitle}>{e.courseTitle ? e.courseTitle : e.major ? e.major : null}</p>
                    <p className={s.experienceText}>{e.name}</p>
                  </Col>
                  <Col xs={12} xl={6} className={s.selectCol}>
                    <FormControl fullWidth>
                      <Select value={es.used} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, selectedId, event.target.value)}>
                        {gedUsage}
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                );
              }
              else {
                //else its GEDDegree
                items.push(<Row key={"ee-" + e.idHash} className={s.experienceRow}>
                  <Col className={s.experienceCol} xs={12} xl={6}>
                    <p className={s.experienceTextTitle}>{e.major ? e.major : e.courseTitle ? e.courseTitle : null}</p>
                    <p className={s.experienceText}>{e.name}</p>
                  </Col>
                  <Col xs={12} xl={6} className={s.selectCol}>
                    <FormControl fullWidth>
                      <Select value={es.used} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, selectedId, event.target.value)}>
                        {e.degTypeId === 1 && gedUsage}
                        {e.degTypeId > 1 && edUsage}
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                );
              }
            }
          })
        }
        if (e.skills.length === 0 || !match) {
          if (e.edType === EdType.Course) {
            // if type is Course
            items.push(<Row key={"c-" + e.idHash} className={s.experienceRow}>
              <Col className={s.experienceCol} xs={12} xl={6}>
                <p className={s.experienceTextTitle}>{e.courseTitle ? e.courseTitle : e.major ? e.major : null}</p>
                <p className={s.experienceText}>{e.name}</p>
              </Col>
              <Col xs={12} xl={6} className={s.selectCol}>
                <FormControl fullWidth>
                  <Select value={0} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, selectedId, event.target.value)}>
                    {gedUsage}
                  </Select>
                </FormControl>
              </Col>
            </Row>
            );
          }
          else {
            //else its GEDDegree
            items.push(<Row key={"cc-" + e.idHash} className={s.experienceRow}>
              <Col className={s.experienceCol} xs={12} xl={6}>
                <p className={s.experienceTextTitle}>{e.major ? e.major : e.courseTitle ? e.courseTitle : null}</p>
                <p className={s.experienceText}>{e.name}</p>
              </Col>
              <Col xs={12} xl={6} className={s.selectCol}>
                <FormControl fullWidth>
                  <Select value={0} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, selectedId, event.target.value)}>
                    {e.degTypeId === 1 && gedUsage}
                    {e.degTypeId > 1 && edUsage}
                  </Select>
                </FormControl>
              </Col>
            </Row>
            );
          }
        }
      })

      // Display all life experiences
      activities.map((e: ActivityExperience, i: number): void => {
        let match: boolean = false;
        if (e.skills.length > 0) {
          e.skills.map((skill: ExperienceSkill): void => {
            const es: ExperienceSkill = skill;
            if (es.skillId === selectedId) {
              match = true;
              items.push(<Row key={"a-" + e.idHash} className={s.experienceRow}>
                <Col className={s.experienceCol} xs={12} xl={6}>
                  <p className={s.experienceTextTitle}>{e.role}</p>
                  <p className={s.experienceText}>{e.org}</p>
                </Col>
                <Col xs={12} xl={6} className={s.selectCol}>
                  <FormControl fullWidth>
                    <Select value={es.used} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, selectedId, event.target.value)}>
                      {usage}
                    </Select>
                  </FormControl>
                </Col>
              </Row>
              );
            }
          })
        }
        if (!match || e.skills.length === 0) {
          items.push(<Row key={"aa-" + e.idHash} className={s.experienceRow}>
            <Col className={s.experienceCol} xs={12} xl={6}>
              <p className={s.experienceTextTitle}>{e.role}</p>
              <p className={s.experienceText}>{e.org}</p>
            </Col>
            <Col xs={12} xl={6} className={s.selectCol}>
              <FormControl fullWidth>
                <Select value={0} onChange={(event: any) => this.props.store.profileStore.updateSkillUsage(e.idHash, selectedId, event.target.value)}>
                  {usage}
                </Select>
              </FormControl>
            </Col>
          </Row>
          );
        }
      })

      if (items.length === 0) {
        items.push(<div style={{ display: "inline-flex" }} key="exp-first-notification">
          <p>First you need to </p>
          <Button color="secondary" onClick={() => hashHistory.push('profile/add-experience/')}>{local.addExp}</Button>
        </div>)
      }

      return (<div>{items}</div>)
    }
}


@observer
export default class SkillsToExperience extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;

    return (<div>
      {this.props.store.profileStore.skillsViewMode === ProfileSkillState.NoSelection &&
        <Row>
        <Col xs={12}><h5 className={s.header}>{local.profile.skillEditorTitle}</h5>
          <p>{local.profile.clickSkill}</p></Col>
        </Row>}
       {this.props.store.profileStore.skillsViewMode === ProfileSkillState.UpdateSkillView && <UpdateSkill store={this.props.store} />}
       {this.props.store.profileStore.skillsViewMode === ProfileSkillState.SkillsToExpView && <SkillsGraph store={this.props.store} />}
       {this.props.store.profileStore.skillsViewMode === ProfileSkillState.AddSkillView && <AddNewSkill store={this.props.store} />}   
      </div >)
  }
}


// WEBPACK FOOTER //
// ./src/components/profile/skillMapping/index.tsx